import { uiLang } from './store';

export function L(str) {
    if (!str) return "";
    
    let output = str;
    const langCode = getLangCode();
    const segs = str.split('|');

    for (let i = 0; i < segs.length; i++) {
        const seg = segs[i].trim();

        if (seg.indexOf(`${langCode}:`) === 0)
            output = seg.substring((`${langCode}:`).length, output.length);
    }

    return output.trim();
}

function getLangCode() {
    let langCode;

    const unsubscribe = uiLang.subscribe(value => {
        langCode = value;
    });

    unsubscribe();

    return langCode;
}